'use client'
import { PropsWithChildren, useEffect } from 'react'

import { WaitForStableAuthState } from './WaitForStableAuthState'
import { useAppAuth } from './hooks'
import { useNavigation } from './NavigationContext'

function EnforceAuthenticationInner({ children }: PropsWithChildren) {
  const { isSignedIn } = useAppAuth()
  const navigation = useNavigation()

  useEffect(() => {
    if (!isSignedIn) {
      navigation.navigate({
        name: 'enforce_auth_redirect',
        route: '/',
      })
    }
  }, [isSignedIn, navigation])

  return isSignedIn ? <>{children}</> : null
}

export function EnforceAuthentication({ children }: PropsWithChildren) {
  return (
    <WaitForStableAuthState>
      <EnforceAuthenticationInner>{children}</EnforceAuthenticationInner>
    </WaitForStableAuthState>
  )
}
